<template>
  <div class="info-box">
    <div class="flex-1 gap-x-5 grid grid-cols-2 overflow-hidden">
      <div class="flex flex-col overflow-hidden">
        <div
          class="flex-1 mt-3 bg-gray-100 p-3 rounded-lg flex flex-col gap-y-3 overflow-hidden"
        >
          <el-input
            v-model="state.attendee_params.keywords"
            clearable
            placeholder="关键字"
            @keyup.enter="onLoadAttendee()"
            @clear="onLoadAttendee()"
          >
            <template #suffix>
              <el-icon
                color="#a2a2a2"
                title="搜索"
                class="font-bold cursor-pointer hover:opacity-60"
                ><Search
              /></el-icon>
            </template>
          </el-input>
          <div
            class="flex-1 overflow-y-auto flex flex-col gap-y-3"
            :class="state.attendee_data?.length > 6 ? 'pr-3' : ''"
          >
            <div
              v-for="item in state.attendee_data"
              :key="item"
              class="flex items-center p-2.5 rounded-lg gap-x-3 hover:opacity-60 cursor-pointer bg-white"
              @click="onSelect(item)"
            >
              <c_Avatar
                v-if="item.id"
                :file_url="item.conferee?.avatar_attachment?.file_url"
                :size="10"
                :title="item.conferee?.name?.slice(0, 1)"
              />
              <div class="flex-1">
                <ul class="flex items-center">
                  <li class="flex-1 gap-x-3 flex items-center">
                    <strong
                      style="color: var(--el-color-primary)"
                      class="cursor-pointer hover:underline"
                    >
                      {{ item.conferee?.name }}
                    </strong>
                    <c_sex
                      :value="item.conferee?.sex"
                      v-if="item.conferee?.id"
                    />
                    <text class="text-sm text-gray-400">{{
                      $phoneFormat(item.conferee?.phone)
                    }}</text>
                    <c_status
                      arrName="Meeting_Attend_Type"
                      :value="item.attend_type"
                      showBg
                      :size="11"
                      :key="item.attend_type"
                    />
                  </li>
                </ul>
                <ul class="flex flex-wrap gap-x-2 gap-y-1 mt-1">
                  <el-tag
                    type="info"
                    size="small"
                    v-for="item in item.d_conferee_tag_json_arr"
                    :key="item"
                  >
                    {{ item }}
                  </el-tag>
                </ul>
              </div>
              <el-icon
                v-if="state.select_data?.some((w) => w.id == item.id)"
                color="#080"
                :size="16"
              >
                <Select />
              </el-icon>
            </div>
          </div>
          <div class="flex justify-center">
            <el-pagination
              layout="prev, pager, next"
              :total="state.attendee_count"
              :background="false"
              size="small"
              :default-page-size="20"
              style="
                --el-pagination-bg-color: transparent;
                --el-pagination-button-disabled-bg-color: transparent;
              "
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col overflow-hidden">
        <div class="flex items-center">
          <text class="text-xs text-gray-400">导入身份：</text>
          <el-select
            v-model="state.d_attend_role_id"
            class="!w-24"
            size="small"
            :empty-values="[null, undefined, 0]"
          >
            <el-option
              v-for="option in state.role_data"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
          </el-select>
          <el-tooltip
            effect="dark"
            content="默认导入身份，该项选定后，后续勾选的嘉宾人员身份默认设置为该项，也可手动更改"
          >
            <el-icon class="cursor-pointer ml-1">
              <QuestionFilled />
            </el-icon>
          </el-tooltip>
          <div class="flex-1 text-right">
            已选{{ state.select_data?.length }}人
          </div>
        </div>
        <div class="flex-1 overflow-y-auto flex flex-col gap-y-1 pr-3">
          <div
            v-for="item in state.select_data"
            :key="item"
            class="flex p-2.5 rounded-lg gap-x-5"
            :class="
              item.d_conferee_tag_json_arr?.length > 0 ? '' : ' items-center'
            "
          >
            <c_Avatar
              v-if="item.conferee?.id"
              :file_url="item.conferee?.avatar_attachment?.file_url"
              :size="10"
              :title="item.conferee?.name?.slice(0, 1)"
            />
            <div class="flex-1 shrink-0">
              <ul class="flex items-center whitespace-nowrap gap-x-3">
                <li class="flex-1 gap-x-3 flex items-center">
                  <strong style="color: var(--el-color-primary)">
                    {{ item.conferee?.name }}
                  </strong>
                  <c_sex :value="item.sex" v-if="item.conferee?.id" />
                  <text>{{ $phoneFormat(item.conferee?.phone) }}</text>
                </li>
                <el-select
                  v-model="item.d_attend_role_id"
                  class="!w-24"
                  size="small"
                  :empty-values="[null, undefined, 0]"
                >
                  <el-option
                    v-for="option in state.role_data"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
                <el-icon
                  @click="
                    state.select_data = state.select_data.filter(
                      (data) => data.id != item.id,
                    )
                  "
                  color="#f00"
                  :size="20"
                  class="hover:!text-red-300 cursor-pointer"
                >
                  <CircleClose />
                </el-icon>
              </ul>
              <ul class="flex flex-wrap gap-x-2 gap-y-1 mt-1">
                <el-tag
                  type="info"
                  size="small"
                  v-for="(tag, index) in item.d_conferee_tag_json_arr"
                  :key="tag"
                >
                  {{ tag }}
                </el-tag>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { dic_getAttendRole } from "@/http/data";
import {
  meeting_agenda_attendee_list,
  meeting_agenda_attendee_addBatch,
} from "@/http/meeting";
import { ElMessage, ElMessageBox } from "element-plus";
import { onDeleteConfirm } from "@/utils/funcs";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
    meeting_agenda_id: Number, //议程id
  },
  setup(props, { emit }) {
    const state = reactive({
      type: 1,
      totalCount: 100,
      attendee_params: {
        page: 1,
        meeting_id: props.meeting_id,
        meeting_agenda_id: props.meeting_agenda_id,
        attend_type: 1,
      },
      list_data: [],
      select_data: [],
    });
    onMounted(() => {
      onLoadRole();
      onLoadAttendee();
    });

    //加载会议参会人
    const onLoadAttendee = () => {
      delete state.attendee_data;
      meeting_agenda_attendee_list(state.attendee_params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.attendee_data = list;
          state.attendee_count = count;
        }
      });
    };

    //获取嘉宾身份数据字典
    const onLoadRole = () => {
      dic_getAttendRole().then((res) => {
        if (res.status == 200) {
          state.role_data = res.data?.data;
        }
      });
    };

    const onSelect = (item) => {
      if (state.select_data.some((w) => w.id == item.id)) {
        state.select_data = state.select_data.filter((w) => w.id != item.id);
      } else {
        state.select_data.push({
          ...item,
          d_attend_role_id: state.d_attend_role_id,
        });
      }
    };

    const onSubmit = () => {
      if (state.select_data?.length > 0) {
        ElMessageBox.confirm(
          `您本次共选择<strong style="color: #080">${state.select_data?.length}</strong>人，是否确定导入当前会议？`,
          "导入参会人",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            customClass: "c-delete-dialog",
            cancelButtonClass: "is-plain",
          },
        ).then(() => {
          meeting_agenda_attendee_addBatch({
            meeting_id: props.meeting_id,
            meeting_schedule_id: props.meeting_schedule_id,
            meeting_agenda_id: props.meeting_agenda_id,
            batch_data: JSON.stringify(
              state.select_data.map((m) => {
                return {
                  meeting_attendee_id: m.id,
                  conferee_id: m.conferee?.id,
                  d_attend_role_id: m.d_attend_role_id,
                };
              }),
            ),
          }).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        });
      } else {
        ElMessage.warning("请选择要操作的数据！");
      }
    };

    const onDelete = (item) => {
      onDeleteConfirm(meeting_agenda_attendee_delete, item.id, onLoadSelect, {
        filed: "嘉宾",
        name: item.name,
      });
    };

    return { state, onLoadAttendee, onSelect, onSubmit, onDelete };
  },
};
</script>

<style lang="less" scoped></style>
